import { cn } from "@/utils";
import type { FileRecord } from "@cohesive/api-client";
import { pickFileRecordMediaURL } from "@cohesive/ui-components";
import { useState } from "react";
import { LoadingOverlay } from "../LoadingOverlay";
import { getFileRecordName } from "../contentType";
import { useFileRecordVersionPreview } from "../versioning/FileRecordVersioningContext";

export function PdfContent({ record }: { record: FileRecord }) {
  const [loaded, setLoaded] = useState(false);
  const { previewMediaUrl } = useFileRecordVersionPreview();
  const mediaUrl =
    previewMediaUrl ??
    pickFileRecordMediaURL(record, "full") ??
    pickFileRecordMediaURL(record, "thumbnail");

  if (!mediaUrl) {
    return (
      <div className="flex items-center justify-center h-full text-sm text-muted-foreground">
        PDF not available.
      </div>
    );
  }

  // Native browser PDF viewer through presigned S3 URL. `#navpanes=0` hides
  // the sidebar, `view=FitH` fits horizontally — matches FileDetailPane so
  // the two panes feel interchangeable.
  return (
    <div className="relative h-full w-full bg-muted/20">
      <iframe
        key={mediaUrl}
        src={`${mediaUrl}#navpanes=0&scrollbar=1&view=FitH`}
        title={getFileRecordName(record)}
        className={cn(
          "w-full h-full border-0 transition-opacity duration-300",
          loaded ? "opacity-100" : "opacity-0",
        )}
        onLoad={() => setTimeout(() => setLoaded(true), 300)}
      />
      {!loaded && <LoadingOverlay />}
    </div>
  );
}
